module.exports = __webpack_public_path__ + "img/dhl.1fac00a7.png";